import { supabase } from './supabase';

// Jarak antara 2 titik koordinat (km), rumus Haversine.
export function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // radius bumi (km)
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Ambil koordinat outlet & radius delivery dari app_settings (diisi admin di Settings).
export async function getDeliverySettings() {
  const { data } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', ['outlet_lat', 'outlet_lng', 'delivery_radius_km']);
  const map = {};
  (data || []).forEach((r) => { map[r.key] = r.value; });
  const lat = map.outlet_lat ? parseFloat(map.outlet_lat) : null;
  const lng = map.outlet_lng ? parseFloat(map.outlet_lng) : null;
  const radiusKm = map.delivery_radius_km ? parseFloat(map.delivery_radius_km) : 3;
  return {
    lat: Number.isFinite(lat) ? lat : null,
    lng: Number.isFinite(lng) ? lng : null,
    radiusKm: Number.isFinite(radiusKm) ? radiusKm : 3,
  };
}

// Minta lokasi user saat ini via browser Geolocation API.
export function getCurrentPosition(options = { enableHighAccuracy: true, timeout: 10000 }) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject(new Error('Browser tidak mendukung lokasi')); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => reject(err),
      options
    );
  });
}
